import { defineComponent as _defineComponent } from 'vue';
import localize from "@/utils/localization";
import DiskUsageSummary from "./DiskUsageSummary.vue";
import IconCard from "@/components/IconCard.vue";
import { reactive } from "vue";
import { useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StorageDashboard',
    setup(__props) {
        const router = useRouter();
        const texts = reactive({
            title: localize("Storage Dashboard"),
            subtitle: localize("Here you can see an overview of your disk usage status."),
            freeSpace: {
                title: localize("Is your usage more than expected?"),
                description: localize("Find out what is eating up your space and learn how to easily and safely free up some of it."),
                icon: "fas fa-broom fa-6x",
                buttonText: localize("Free up disk usage"),
            },
            explore: {
                title: localize("Visually explore your disk usage"),
                description: localize("Want to know what histories or datasets take up the most space in your account? Here you can explore your disk usage in a visual way."),
                icon: "fas fa-chart-pie fa-6x",
                buttonText: localize("Explore now"),
            },
        });
        function goToStorageManager() {
            router.push({ name: "StorageManager" });
        }
        function goToHistoriesOverview() {
            router.push({ name: "HistoriesOverview" });
        }
        return { __sfc: true, router, texts, goToStorageManager, goToHistoriesOverview, DiskUsageSummary, IconCard };
    }
});
